module.exports = __webpack_public_path__ + "img/zhongshan15.09ddfc80.jpg";